
(() => {
  'use strict';

  if (window.ShipAndCoDeliveryGuard) return;

  const DATE_KEY = 'shipandco-配達希望日';
  const TIME_KEY = 'shipandco-配達希望時間帯';

  const root = window.Shopify?.routes?.root || '/';
  const base = root.endsWith('/') ? root : `${root}/`;

  async function cartRequest(path, options = {}) {
    const response = await fetch(`${base}${path}`, {
      credentials: 'same-origin',
      cache: 'no-store',
      ...options
    });

    if (!response.ok) {
      throw new Error(`Cart API error: ${response.status}`);
    }

    return response.json();
  }

  // YYYY-MM-DD または YYYY/MM/DD を厳密に解析する
  function parseDate(value) {
    const match = /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/
      .exec(String(value).trim());

    if (!match) return null;

    const [, y, m, d] = match.map(Number);
    const timestamp = Date.UTC(y, m - 1, d);
    const date = new Date(timestamp);

    if (
      date.getUTCFullYear() !== y ||
      date.getUTCMonth() !== m - 1 ||
      date.getUTCDate() !== d
    ) {
      return null;
    }

    return timestamp;
  }

  // 端末のタイムゾーンに関係なく日本時間で今日を取得
  function getTodayJST() {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());

    const get = (type) =>
      Number(parts.find(p => p.type === type).value);

    return Date.UTC(
      get('year'),
      get('month') - 1,
      get('day')
    );
  }

  async function inspectAndRepair() {
    const cart = await cartRequest('cart.js');
    const rawDate = cart.attributes?.[DATE_KEY];

    if (!rawDate) {
      return { status: 'empty' };
    }

    const selectedDate = parseDate(rawDate);

    if (selectedDate === null) {
      return { status: 'invalid_format', value: rawDate };
    }

    if (selectedDate >= getTodayJST()) {
      return { status: 'valid' };
    }

    // 過去の日付と、それに紐づく時間帯のみ解除
    await cartRequest('cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [DATE_KEY]: '',
          [TIME_KEY]: ''
        }
      })
    });

    // 更新後に必ず再取得して保存状態を確認
    const verifiedCart = await cartRequest('cart.js');

    if (verifiedCart.attributes?.[DATE_KEY]) {
      throw new Error('Delivery date was not cleared');
    }

    return {
      status: 'reset',
      previousDate: rawDate
    };
  }

  let inFlight = null;

  function run() {
    if (inFlight) return inFlight;

    inFlight = inspectAndRepair().finally(() => {
      inFlight = null;
    });

    return inFlight;
  }

  window.ShipAndCoDeliveryGuard = { run };
})();
